import { Container } from "@components/wrapper"
import { HARISENIN_PUBLIC_PAGE_ASSETS } from "@constants/pictures"
import clsx from "clsx"
import Image from "next/image"
import React from "react"
import Carousel from "react-multi-carousel"
import { BootcampSliderArrow, SliderScrollArrow } from "."
import { CustomDot } from "../general"
import { COMMUNITIES_ASSETS, COMMUNITIES_ASSETS_MOBILE } from "../general/constant"
import { BootcampHeading } from "../general/ProgramHeading"

export const BootcampCommunity = ({ screenWidth }: { screenWidth: number }) => {
  // Slider breakpoint
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  }

  return (
    <div className="sm:py-20 py-10 bg-[#101820]">
      <Container>
        <div className="sm:mb-9 relative mb-6">
          <BootcampHeading
            id="community"
            title="Komunitas"
            subTitle="Terus Berkembang Bersama Para Alumni Harisenin.com!"
            type="green"
          />
        </div>

        {/* Web */}
        <div className="grid gap-9 relative">
          <Carousel
            responsive={responsive}
            ssr={true} // means to render carousel on server-side.
            containerClass={clsx("sm:-ml-4.5 -mx-4.5")}
            itemClass="px-4.5"
            arrows={false}
            {...(screenWidth > 576 && {
              customButtonGroup: (
                <BootcampSliderArrow
                  length={6}
                  displayedSlide={1}
                  className="gap-6 justify-center"
                />
              ),
              renderButtonGroupOutside: true,
              partialVisible: true,
            })}
            {...(screenWidth < 576 && {
              renderArrowsWhenDisabled: true,
              renderButtonGroupOutside: true,
              partialVisible: true,
              customButtonGroup: (
                <SliderScrollArrow
                  length={6}
                  displayedSlide={1}
                  customBackground="bg-[#2D343B]"
                  customMargin="mt-0"
                />
              ),
              autoPlaySpeed: 3000,
            })}
          >
            {COMMUNITIES_ASSETS.map((com, idx) => (
              <div
                key={idx}
                className={clsx(
                  "bg-body-bg rounded-[20px] border border-new-grey grid",
                  "sm:p-6 p-3 gap-3"
                )}
              >
                <div
                  className={clsx("font-urbanist font-medium w-full text-center", "sm:text-[32px]")}
                >
                  {com.title}
                </div>

                <div
                  className={clsx(
                    "grid gap-6 sm-only:hidden",
                    com.images.length === 3 ? "grid-cols-3" : "grid-cols-4"
                  )}
                >
                  {com.images.map((img, i) => (
                    <Image
                      key={i}
                      src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/${img}`}
                      width={500}
                      height={500}
                      alt={`${com.title} ${i + 1}`}
                      className={clsx("rounded-large object-cover", "sm:h-[200px] w-full")}
                    />
                  ))}
                </div>

                <div className={clsx("sm:hidden grid gap-3", "grid-cols-2")}>
                  {com.images.length === 4 &&
                    COMMUNITIES_ASSETS_MOBILE[idx].images.map((img, i) => (
                      <Image
                        key={i}
                        src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/${img}`}
                        width={500}
                        height={500}
                        alt={`${com.title} ${i + 1}`}
                        className={clsx("rounded-large object-cover", "h-[72vw] w-full")}
                      />
                    ))}

                  {com.images.length === 3 && (
                    <>
                      <Image
                        src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/${COMMUNITIES_ASSETS_MOBILE[idx].images[0]}`}
                        width={500}
                        height={500}
                        alt={`${com.title} 1`}
                        className={clsx(
                          "rounded-large object-cover",
                          "w-full col-span-2 h-[34.5vw]"
                        )}
                      />
                      {[
                        COMMUNITIES_ASSETS_MOBILE[idx].images[1],
                        COMMUNITIES_ASSETS_MOBILE[idx].images[2],
                      ].map((img, i) => (
                        <Image
                          key={i}
                          src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/${img}`}
                          width={500}
                          height={500}
                          alt={`${com.title} ${i + 1}`}
                          className={clsx("rounded-large object-cover", "h-[34.5vw] w-full")}
                        />
                      ))}
                    </>
                  )}
                </div>
              </div>
            ))}
          </Carousel>
        </div>
      </Container>
    </div>
  )
}
